module.exports = __webpack_public_path__ + "img/empty-state-plans.e4b79379.png";